/*@ngInject*/
const UIClickOutsideDirective = function ($document) {

    let linkFunction = function ($scope, $elm, $attrs) {

        let handleClick = function (event) {
            let isToggleButton = ($attrs.toggleButtonClass) ? $(event.target).hasClass($attrs.toggleButtonClass) : false,
                isChild = $elm.has(event.target).length > 0,
                isSelf = $elm[0] === event.target,
                isDayPickerChild = $(event.target).closest('.uib-daypicker').length > 0,
                isMonthPickerChild = $(event.target).closest('.uib-monthpicker').length > 0,
                isYearPickerChild = $(event.target).closest('.uib-yearpicker').length > 0,
                isDayChild = $(event.target).closest('.uib-day').length > 0,
                isElement = isSelf || isChild || isDayPickerChild || isMonthPickerChild || isYearPickerChild || isToggleButton || isDayChild;

            if (!isElement) {
                $scope.$apply($attrs.uiClickOutside);
            }
        };

        $scope.$on('$destroy', function () {
            $document.off('click.uiClickOutside');
        });

        $document.on('click.uiClickOutside', handleClick);
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('uiClickOutside', UIClickOutsideDirective);
